import {api, useApiQuery} from '@/api';
import utils from 'utils';

import {useEffect, useState} from 'react';

import {useLabel} from '@/hooks/export';

export const useCart = (props?: {
    enabled?: boolean,
}) => {
    const label = useLabel();
    const query = useApiQuery('getCart', {}, !props?.enabled);

    const cart : void | apiCart = query.data;

    const [productOptionsImages, setProductOptionsImages] = useState([]); // MachineRequestAttachment type

    const [contactForm, setContactForm] = useState({
        contactEmail: '',
        contactFirstName: '',
        contactLastName: '',
        contactPhone: '',
        doSaveAddress: false,
        doSaveContact: false,
        execCity: '',
        execCompany: '',
        execPostalCode: '',
        execStreet: '',
        info2: '',
        info: label.billingCompanyByUserBranch,
        invoiceCity: '',
        invoiceCompany: '',
        invoicePostalCode: '',
        invoiceStreet: '',
    });

    const addProductOptionsImage = (productId: string, attachment: machineRequestAttachment) => {
        if (!Array.isArray(productOptionsImages[productId])) {
            productOptionsImages[productId] = [];
        }

        productOptionsImages[productId].push(attachment);

        setProductOptionsImages({...productOptionsImages});
    };

    // fixme: tsc
    useEffect(() => {
        // @ts-ignore
        if (cart?.contactForm && !contactForm.invoiceCity) {
            setContactForm({
                ...contactForm,
                // @ts-ignore
                ...cart?.contactForm,
            })
        }
    }, [cart]);

    return {
        query,
        cart,
        updateItem,
        updateNote,
        updateContactForm,
        clean: () => api.cart.clean(),
        submit: async () => {
            const productOptionsImagesBase64 = {};

            for (const [key, values] of Object.entries(productOptionsImages)) {
                productOptionsImagesBase64[key] = await Promise.all(
                    values.map(async (item) => {
                        const base64File = await utils.fileToBase64(item.file);
                        return {
                            ...item,
                            file: base64File,
                        };
                    })
                );
            }

            // fixme: to much is sent in products
            return api.cart.submit({
                products: (cart as unknown as apiCart).list, // fixme - temp fix
                productOptionsImages: productOptionsImagesBase64,
            });
        },
        saved: {
            execAddresses: useApiQuery('getSavedAddresses', {}, !props?.enabled).data, // todo: add types
            contacts: useApiQuery('getSavedContacts', {}, !props?.enabled).data,
        },
        contactForm,
        setContactForm,
        productOptionsImages,
        setProductOptionsImages,
        addProductOptionsImage,
        flags: {
            isMontaz: (cart as unknown as apiCart)?.flags?.isMontaz,
            isMontazVzdusnice: (cart as unknown as apiCart)?.flags?.isMontazVzdusnice,
            isVidlice: (cart as unknown as apiCart)?.flags?.isVidlice,
            isSelfPickup: (cart as unknown as apiCart)?.flags?.isSelfPickup,
            isOrderAllowed: (cart as unknown as apiCart)?.flags?.isOrderAllowed,
        },
    };
};

const updateItem = (
    id: string,
    qty: number,
    additionalServices: [additionalService],
    additionalInfo?: {
        manufacturerNum: string,
        internalNum: string,
        note: string,
        execDate: string, // todo: check date format?
    },
) => {
    // todo: clear execDate if services total qty = 0

    return api.cart.update({
        productId: id,
        qty: qty,
        additionalServices: additionalServices,
        additionalInfo: additionalInfo || {},
    });
};

const updateNote = (note: string) => {
    return api.cart.updateNote({
        note,
    });
};

const updateContactForm = (contactForm) => {
    return api.cart.updateContactForm(contactForm);
}
